export default __webpack_public_path__ + "static/media/1.06d9a1f9.jpg";